export function getWorkingHours(day: Date) {
  const hours = []
  day.setHours(0, 0, 0, 0)
  for (let i = 10; i < 20; i += 1) {
    hours.push({
      key: i,
      label: `${i}h - ${i + 1}h`,
      value: formatDate(addHours(day, i)),
    })
  }
  return hours
}

export function getHoursOptions() {
  const date = new Date()
  const currentHour = date.getHours()
  const hoursOptions: any = []

  const days = ['HOY:', 'MAÑANA:']
  days.forEach((day: string, i) => {
    hoursOptions.push({
      key: day,
      label: day,
      value: i,
      disabled: true,
    })
    getWorkingHours(addDays(date, i)).forEach((hour: any) => {
      hoursOptions.push({ ...hour, disabled: hour.key < currentHour + 1 && day === 'HOY:' })
    })
  })
  return hoursOptions
}

function addDays(date: Date, days: number): Date {
  const dateCopy = new Date(date)
  dateCopy.setDate(dateCopy.getDate() + days)
  return dateCopy
}

function addHours(date: Date, numOfHours: number): Date {
  const dateCopy = new Date(date.getTime())
  dateCopy.setTime(dateCopy.getTime() + numOfHours * 60 * 60 * 1000)
  return dateCopy
}

function formatDate(date: Date): string {
  const dateString = toIsoString(date)
  return dateString.substring(0, dateString.indexOf('+')).replace('T', ' ')
}

function toIsoString(date: Date): string {
  const tzo = -date.getTimezoneOffset()
  const dif = tzo >= 0 ? '+' : '-'
  const pad = (num: number) => (num < 10 ? '0' : '') + num

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}${dif}${pad(
    Math.floor(Math.abs(tzo) / 60),
  )}:${pad(Math.abs(tzo) % 60)}`
}
